module.exports = __webpack_public_path__ + "img/struja-idle.b9a3dc00.svg";